<template>
  <b-modal size="md" v-model="show" centered :title="'Auftragsgruppe anlegen'"
  >
    <b-row>
      <b-col>
        <label for="name">Bezeichnung</label>
        <b-form-input id="name" type="text"
                      v-model="augr.name"
                      class="mb-2 text-black"
                      maxlength="50"
                      aria-describedby="input-live-help input-live-feedback"
                      :state="nameState"
        ></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
          Diese Bezeichnung ist bereits vergeben.
        </b-form-invalid-feedback>
        <b-form-text id="input-live-help" style="text-align: right">{{augr.name.length}}/50</b-form-text>
        <b-form-group label="Für interne oder externe Aufträge ?">
          <b-form-radio-group
              v-model="internal">
            <b-form-radio :value="true">Intern</b-form-radio>
            <b-form-radio :value="false">Extern</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Für Dauer- oder Einzelaufträge ?">
          <b-form-radio-group
              v-model="dauer">
            <b-form-radio :value="true">Dauerauftrag</b-form-radio>
            <b-form-radio :value="false">Einzelauftrag</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <label for="augr_type">Auftragsgruppentyp</label>
        <b-form-select :options="augrTypeSelects" id="augr_type" :plain="true"
                       v-model="augrType"
                       class="mb-2 text-black"
        ></b-form-select>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onCreate">
        Anlegen
      </b-button>
    </template>
  </b-modal>
</template>

<script>


export default {
  name: "ChangeTodoDialog",
  props:{
    augrTypesAvailable: {
      type: Object,
      default: () => {
        return {
          fahr: true,
          play: false,
          street: false,
      };
      }
    },
    augrNames: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      show: false,
      augr: {
        name: '',
        access: '',
        billing_type: '',
        target_time: 'J',
        sti: 'STI',
        augr_type: '',
      },
      internal: true,
      dauer: true,
      augrType: '',
    }
  },
  computed: {
    nameState() {
      let trimmed = this.augr.name.trim();
      let exists = false;
      for (let i = 0; i < this.augrNames.length; i++) {
        if (this.augrNames[i] === trimmed) {
          exists = true;
          break;
        }
      }
      return !exists;
    },
    canContinue() {
      let trimmed = this.augr.name.trim();
      if (this.augr.name.trim().length === 0) {
        return false;
      }
      let exists = false;
      for (let i = 0; i < this.augrNames.length; i++) {
        if (this.augrNames[i] === trimmed) {
          exists = true;
          break;
        }
      }
      return !exists;
    },
    augrTypeSelects() {
      let res = [
        {text: "Normal", value: ""},
        {text: "Kostenstelle", value: "KOST"},
      ];
      if (this.augrTypesAvailable.fahr) {
        res.push({text: "Fahrzeuge", value: "FAHR"})
      }
      if (this.augrTypesAvailable.play) {
        res.push({text: "Spielplätze", value: "PLAY"})
      }
      if (this.augrTypesAvailable.street) {
        res.push({text: "Straßen", value: "STREET"})
      }
      return res;
    }
  },
  methods: {
    onCreate() {
      this.show = false;
      this.$emit("create-augr", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.augr = {
        name: '',
        access: '',
        billing_type: '',
        target_time: 'J',
        sti: 'STI',
        augr_type: '',
      };
      this.internal = true;
      this.dauer = true;
      this.augrType = '';
      this.show = true;
    },
    getReturnData: function () {
      this.augr.name = this.augr.name.trim();
      this.augr.access = this.augr.name;
      this.augr.billing_type = (this.internal ? "IN" : "EX") + "@" + (this.dauer ? "DA" : "EI") + "@DE";
      if (this.augrType === "KOST" || this.augrType === "FAHR") {
        this.augr.augr_type = this.augrType;
      }
      return {
        augr: this.augr,
        augr_type: this.augrType
      }
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
